export const GET_WITHDRAWAL = 'GET_WITHDRAWAL';
export const GET_WITHDRAWAL_SUCCESS = 'GET_WITHDRAWAL_SUCCESS';
export const GET_WITHDRAWAL_FAIL = 'GET_WITHDRAWAL_FAIL';

export const RESET_WITHDRAWAL_ALERTS_ERRORS = 'RESET_WITHDRAWAL_ALERTS_ERRORS';
